
<!-- Список значений справочника -->

<template>

	<v-select :clearable="false" :value="value" :reduce="obj => obj.value" :options="options" v-on:input="handle_input" clearSearchOnSelect required appendToBody/>

</template>

<script>

import api from "../../../api"

export default
{
	props :
	{
		reference : Object,
		value : String,
	},

	watch :
	{
		reference :
		{
			immediate : true,

			handler(reference)
			{
				var promise

				if(reference.simple_values != null)
					promise = new Promise(resolve => resolve(reference.simple_values))
				else if(reference.service != null)
					promise = api.call(this, reference.service, "get_reference", { reference : reference.name },
						response =>
						{
							var options = []

							response.reference.forEach(value => options.push({ label : value, value : value }))

							return options
						})
				else
					promise = api.call(this, "cadastral_references", "get", { id : reference.id },
						response =>
						{
							var options = []
							var values = new Set()

							if(response.data.original)
								Object.entries(response.data.original).forEach(
									( [ code, value ] ) =>
									{
										options.push({ label : `${code} ( ${value} )`, value : code })
										values.add(code)
									})
							
							response.data.values.forEach(
								value =>
								{
									if(! values.has(value))
										options.push({ label : value, value : value })
								})

							return options
						})

				promise.then(options => { this.options = api.sort_objects_array_by_key(options, "label") })
			}
		},
	},

	data()
	{
		return {
			
			options : [],

		}
	},

	methods :
	{
		handle_input(event)
		{
			this.$emit("input", event)
		},
	}
}

</script>

